import { Grid, Typography, Box } from "@mui/material";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const UserPhoneNumber = ({ label, value, onChange, disabled = false }) => {
  const baseColor = "#1D3D4D";
  const labelColor = "#567D8C";
  const lineDefault = "#E0E0E0";
  const lineHover = "#567D8C";
  const lineFocus = "#1D3D4D";

  return (
    <Grid item xs={12}>
      <Typography
        sx={{
          fontFamily: "Montserrat",
          fontSize: "20px",
          fontWeight: "bold",
          color: labelColor,
        }}
      >
        {label}
      </Typography>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mt: 0.5,

          // Barra inferior
          borderBottom: `2px solid ${lineDefault}`,
          transition: "border-color 150ms ease",

          "&:hover": {
            borderBottomColor: lineHover,
          },

          "&:focus-within": {
            borderBottomColor: lineFocus,
          },

          ...(disabled && {
            borderBottomColor: "#D0D0D0",
            opacity: 0.7,
            pointerEvents: "none",
          }),
        }}
      >
        <PhoneInput
          preferredCountries={["cl", "us", "co"]}
          country={"cl"}
          placeholder="Número de celular"
          value={value}
          onChange={onChange}
          autoFormat
          enableSearch
          disabled={disabled}
          containerStyle={{
            width: "100%",
          }}
          inputStyle={{
            width: "100%",
            border: "none",
            boxShadow: "none",
            background: "transparent",
            fontFamily: "Montserrat",
            fontSize: "16px",
            fontWeight: 500,
            color: baseColor,
            paddingTop: 6,
            paddingBottom: 6,

            paddingLeft: 52,
          }}
          buttonStyle={{
            border: "none",
            background: "transparent",
          }}
          dropdownStyle={{
            fontFamily: "Montserrat",
          }}
          searchStyle={{
            fontFamily: "Montserrat",
          }}
        />
      </Box>
    </Grid>
  );
};

export default UserPhoneNumber;
